var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264-216h109.847v-237.692h212.306V-216H696v-348L480-726.769 264-564v348Zm-51.999 51.999v-425.998L480-791.767l267.999 201.768v425.998H534.154v-237.693H425.846v237.693H212.001ZM480-471.385Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBold);
export default __webpack_public_path__ + "static/media/home-bold.5108cd4dc776e5e8d982808cf0d0825f.svg";
export { ForwardRef as ReactComponent };